<template>
  <mobile-only-bottom-sheet v-model="$store.state.login_dialog" max-width="375">
    <v-sheet>
      <v-container class="pt-0">
        <v-row justify="end">
          <v-col class="text-h6 text-center">
            {{ $t("YOUR_CARD_IS_READY") }}
            <v-btn
              class="float-right"
              icon
              @click="
                $store.dispatch('setLoginDialog', !$store.state.login_dialog)
              "
            >
              <v-icon>
                {{ mdiWindowClose }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="text-center">
            {{ $t("IN_THE_NEXT_STEP_YOU_CAN_PREVIEW_YOUR_CARD") }}
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="auto">
            <SignInWithGoogle @click="signIn" />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col class="mx-auto mt-n6 px-2 white" cols="auto">
            or
          </v-col>
        </v-row>

        <v-form ref="login_form" @submit.prevent="sendUserMobileToServer">
          <v-row>
            <v-col cols="12">
              {{ $t("ENTER_YOUR_MOBILE_NUMBER") }}
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="mobile_number"
                type="tel"
                :rules="rules.mobile"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn
                type="submit"
                color="primary"
                dark
                block
                rounded
                large
                :loading="$store.state.page_loader"
              >
                {{ $t("PROCEED") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-sheet>
  </mobile-only-bottom-sheet>
</template>

<script>
import urls from "@/app-js/urls";
import { mdiWindowClose } from "@mdi/js";
import MobileOnlyBottomSheet from "@/components/MobileOnlyBottomSheet";
import SignInWithGoogle from "@/components/SignInWithGoogle";

export default {
  components: {
    MobileOnlyBottomSheet,
    SignInWithGoogle
  },

  data() {
    return {
      mdiWindowClose,
      mobile_number: "",
      rules: {
        mobile: [
          v => !!v || "Mobile number is required.",
          v => /[5-9][0-9]{9}/.test(v) || "Mobile number must be valid."
        ]
      }
    };
  },

  methods: {
    async signIn() {
      const provider = new this.$fireModule.auth.GoogleAuthProvider();
      const result = await this.$fire.auth().signInWithPopup(provider);
      await this.sendUserInfoToServer(result.additionalUserInfo.profile);
    },

    async sendUserInfoToServer(profile) {
      const url = urls.LOGIN;
      const form = new URLSearchParams();
      form.append("email", profile.email);

      const response = await this.$axios.post(url, form);
      this.$store.dispatch("auth/setAccessToken", response.data.access_token);
      this.$store.dispatch("auth/setUserProfile", profile);
      this.$store.dispatch("setLoginDialog", !this.$store.state.login_dialog);
      this.$emit("authenticated");
    },

    async sendUserMobileToServer() {
      console.log(this.$refs.login_form.validate());
      if (!this.$refs.login_form.validate()) return;
      const url = urls.LOGIN;
      const form = new URLSearchParams();
      form.append("mobile", this.mobile_number);

      const response = await this.$axios.post(url, form);
      this.$store.dispatch("auth/setAccessToken", response.data.access_token);
      this.$store.dispatch("auth/setUserProfile", {
        mobile: this.mobile_number
      });
      this.$store.dispatch("setLoginDialog", !this.$store.state.login_dialog);
      this.$emit("authenticated");
    }
  }
};
</script>

<style scoped>
.signup-with-google-btn {
  display: inline-block;
  font-size: 14px;
  font-family: Roboto;
  color: #ffff;
  font-weight: 500;
  background: #4285f4;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.24), 0px 0px 1px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  background-color: blue;
  cursor: pointer;
}

.signup-with-google-btn:hover {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.google-logo {
  vertical-align: middle;
}

.negative-margin12 {
  margin-top: -12px;
  display: block;
}
</style>
